<template>
  <v-app >
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
        <v-row >
          <v-col>
            <v-card
                class="mb-12"
                color="#393E46"
            >
              <v-card-title>
                <v-btn icon :top="top" :right="right" @click="$router.push({name:'Eventos'})">
                  <v-icon>far fa-times-circle</v-icon></v-btn>
                <v-btn icon :top="top" :right="right" @click="$router.go(-1)">
                <v-icon>fas fa-long-arrow-alt-left</v-icon></v-btn>
              </v-card-title>
              <v-card-text >
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                <v-row >
                  <v-col cols="12" md="12" lg="12" sm="12">
                     <h1 class="text-lg-h3 text-md-h3 text-h4 text-center">Datos del Evento</h1>
                  </v-col>
                   </v-row>

                <v-row justify="center">
                  <v-col cols="12" md="8" lg="8" sm="12">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field v-model="editedItem.nombre" label="Nombre del Evento" :rules="[rules.required]" @keyup="cambiatag" @change="verificaTag" placeholder="Nombre del Evento" aria-required="true"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field  v-model="editedItem.tag" :error="tagError" :error-messages="tagMessages" @change="verificaTag"  prefix="https://tunay.app/acto/" :rules="[rules.required, rules.nospace]" label="Web"   aria-required="true" ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" lg="6">
                          <span class="block text-gray-600 text-sm text-left font-bold mb-2"
                          >Selecciona Fecha Inicial</span
                          >
                          <vc-date-picker  class="inline-block h-full"    is-dark mode="date" :min-date='new Date()' :input-debounce="500" v-model="editedItem.fechaInicio" >
                            <template v-slot="{ inputValue, togglePopover }">
                              <div class="flex items-center">
                                <v-btn

                                    @click="togglePopover()"
                                >
                                  <v-icon>fas fa-calendar</v-icon>
                                </v-btn>
                                <input
                                    :value="inputValue"
                                    class="bg-white  text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                                    style="background-color: white;"
                                    readonly
                                />
                              </div>
                            </template>
                          </vc-date-picker>


                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-dialog
                              ref="dialogt"
                              v-model="modal3"
                              :return-value.sync="time"
                              persistent
                              width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="editedItem.horaInicio"
                                  label="Hora Inicio"
                                  prepend-icon="far fa-clock"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="modal3"
                                v-model="editedItem.horaInicio"
                                format="24hr"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="modal3 = false">Cancelar</v-btn>
                              <v-btn text color="primary" @click="$refs.dialogt.save(editedItem.horaInicio)">OK</v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                        <span class="block text-gray-600 text-sm text-left font-bold mb-2"
                        >Selecciona Fecha Final</span>  <vc-date-picker  class="inline-block h-full"    is-dark mode="date" :min-date='new Date()' :input-debounce="500" v-model="editedItem.fechaFinal" >
                            <template v-slot="{ inputValue, togglePopover }">
                              <div class="flex items-center">
                                <v-btn

                                    @click="togglePopover()"
                                >
                                  <v-icon>fas fa-calendar</v-icon>
                                </v-btn>
                                <input
                                    :value="inputValue"
                                    class="bg-white text-gray-700 w-full py-1 px-2 appearance-none border rounded-r focus:outline-none focus:border-blue-500"
                                    style="background-color: white;"
                                    readonly
                                />
                              </div>
                            </template>
                          </vc-date-picker>

                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-dialog
                              ref="dialoghf"
                              v-model="modal4"
                              :return-value.sync="time"
                              persistent
                              width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="editedItem.horaFinal"
                                  label="Hora Final"
                                  prepend-icon="far fa-clock"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                              ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="modal4"
                                v-model="defaultItem.horaFinal"
                                format="24hr"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="modal4 = false">Cancelar</v-btn>
                              <v-btn text color="primary" @click="$refs.dialoghf.save(editedItem.horaFinal)">OK</v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" lg="12">
                          <v-textarea v-model="editedItem.descripcion" label="Descripción" aria-required="true" ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-text-field type="number" v-model="editedItem.aforo" label="Aforo (0 sin Aforo)" placeholder="0" aria-required="true" value="0"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col></v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6" lg="6" sm="12">
                    <center><v-btn class="primary" @click="save">Grabar y Crear Zonas</v-btn></center>
                  </v-col>
                </v-row></v-form>
              </v-card-text>
            </v-card>

          </v-col>
        </v-row>
        <leftmenueventos :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import moment from "moment-timezone";
import piepagina from "@/components/general/piepagina";
import Leftmenueventos from "@/components/general/leftmenueventos";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  title: 'Crear Evento Paso 3 | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    Leftmenueventos,
    piepagina
  },
  data: () => ({
    drawer: null,
    overlay:false,
    progr: true,
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    dialog: false,
    categoriafiesta: 0,
    tagError:false,
    tagMessages:[],
    tipoevento: 0,
    steps: 4,
    e1: 1,
    top:true,
    right:true,
    direction:'top',
    valid: true,
    imagen:null,
    rules: {
      required: value => !!value || 'Requerido.',
      nospace: v => (v.split(' ').length <= 2) || 'Only one space allowed',
    },
    date: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000),
    date2: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000),
    menu1: false,
    menu2: false,
    menu3: false,
    modal3: false,
    abreviado:'NN',

    modal4: false,
    menu4: false,
    time: null,
    time2: null,
    TipoEventos: [],
    search: '',
    token:'',
    editedItem: {
      activo: true,
      aforo: 0,
      cabecera: "",
      cliente: {},
      contactos: [],
      createdAt: null,
      descripcion: "",
      eventoCategoria: {},
      fechaFinal: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000),
      fechaInicio: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000),
      flyer: "",
      footer: "",
      foto: "",
      horaFinal: "00:00:00",
      horaInicio: "00:00:00",
      id: null,
      lat: 0,
      listaapp: true,
      lng: 0,
      nombre: "",
      promotorcambia: true,
      publicoapp: true,
      qrmail: true,
      tag: "",
      tipoEvento: {},
      ubicacion: "",
      ventapp: true,
    },
    defaultItem: {
      activo: true,
      aforo: 0,
      cabecera: "",
      cliente: {},
      contactos: [],
      createdAt: null,
      descripcion: "",
      eventoCategoria: {},
      fechaFinal: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000),
      fechaInicio: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000),
      flyer: "",
      footer: "",
      foto: "",
      horaFinal: "00:00:00",
      horaInicio: "00:00:00",
      id: null,
      lat: 0,
      listaapp: true,
      lng: 0,
      nombre: "",
      promotorcambia: true,
      publicoapp: true,
      qrmail: true,
      tag: "",
      tipoEvento: {},
      ubicacion: "",
      ventapp: true,
    },
    headers: [
      { text: 'Acciones', value: 'action', sortable: false },
      { text: 'Zonas', value: 'zonas', sortable: false },
      { text: 'Tickets', value: 'tickets', sortable: false },
      { text: 'Contactos', value: 'promotores', sortable: false },
      { text: 'Evento', align: 'left',  value: 'nombre'},
      { text: 'Fecha', value: 'fechai' },
      { text: 'Activo', value: 'activ', sortable: false }

    ]
  }),
  mounted (){
    if(this.cliente == null){
      this.$router.push({ name: 'creacliente' });
    }else{
      if (this.cliente.id > 0){
        this.defaultItem = this.evento;
        this.editedItem = this.defaultItem
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      }else{
        this.$router.push({ name: 'creacliente' });
      } }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    date () {
      this.defaultItem.fechaInicio = this.formatDate(this.date)
    },
    date2 () {
      this.defaultItem.fechaFinal = this.formatDate(this.date2)
    },
  },
  methods : {
    formatDatee(value) {
      return moment(value).locale('es-pe').format("DD MMMM YYYY")
    },
    formatDatree(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },

    remove (item) {
      const index = this.SelectedEventoContacots.indexOf(item)
      if (index >= 0) this.SelectedEventoContacots.splice(index, 1)
    },
    cambiatag(){
      this.defaultItem.tag = this.defaultItem.nombre.toLowerCase().trim().replaceAll(" ","-")
    },
    irubicacion() {

      this.$refs.form.validate()
      if(this.valid){
        store.dispatch("fetchEvento", this.defaultItem);
        this.$router.push({name:'CreaPaso3'});
      }
    },
    getRandomInt(max) {
   return Math.floor(Math.random() * max).toString();
    },
    verificaTag(){
      this.overlay = true

      axios
      .get('eventos/verifica/'+this.defaultItem.tag,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            let tasdg = String(response.data)
            this.overlay = false
            if(tasdg === 'true' ){
              this.tagError = true
              this.tagMessages= ["Esta Web ya existe en el sistema intenta otra"]
              this.defaultItem.tag = this.defaultItem.tag + this.getRandomInt(20)
              this.verificaTag()
            }else {
              this.tagError = false
              this.tagMessages =[]
            }
                })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false
          });
    },
    formatDate (date) {
      return moment(date).locale('es-pe').format("YYYY-MM-DD");
    },
    formatDateer (date) {
      return moment(date).locale('es-pe').format("DD-MM-YYYY");
    },
    formatDarete (date) {
      var fec = moment(date).locale('es-pe');
      console.log(fec);
      return fec.tz(this.cliente.timeZone.timeZone).format("DD-MM-YYYY");
    },
    formatTime (date) {
      let hora = new Date('2020-10-10 '+date)
      return moment(hora).locale('es-pe').format("HH:mm");
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    save(){
      this.overlay = true
      var bodyFormData2 = new FormData();

      this.editedItem.fechaInicio = this.formatDateer(new Date(this.editedItem.fechaInicio))
      this.editedItem.fechaFinal = this.formatDateer(new Date(this.editedItem.fechaFinal))

      if(this.editedItem.lat === ""){
        this.editedItem.lat = 0
        this.editedItem.lng = 0
      }
      this.defaultItem = this.editedItem
      store.dispatch("fetchEvento", this.defaultItem);

      bodyFormData2.append("data",JSON.stringify(this.defaultItem));
      axios
      .post('eventos/nuevo',bodyFormData2,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
        console.log(response);
        this.overlay = false
        store.dispatch("fetchEvento", response.data);
        if(!this.defaultItem.eventoCategoria.pago ){
          this.$router.push({name:'Eventos'});

        }else{
          this.$router.push({name:'ZonaEvento'});

        }
      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false
          });

    }


  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Evento' : 'Editar Evento'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      cliente: "cliente",
      evento: "evento"
    })
  }
};
</script>
<style >
input .bg-white{

  color: white;
}
</style>
